module.exports = __webpack_public_path__ + "img/Player202410.01d61c1b.png";